/*
 * KC Theme — dual-thumb price slider.
 *
 * The two <input type="range"> elements are the real form fields and work on
 * their own (drag + submit) with this script absent. All this adds is:
 *   - a guard so the thumbs can't cross,
 *   - the live labels + track fill,
 *   - dropping a value from the query string when it's still at its extreme,
 *     so the URL stays clean (?filter.v.price.lte=500, not gte=0&lte=500).
 *
 * Submitting is left to the facet form's own change handler in drawer.js.
 */
if (!customElements.get('price-range')) {
  customElements.define(
    'price-range',
    class PriceRange extends HTMLElement {
      connectedCallback() {
        this.min = this.querySelector('[data-pr="min"]');
        this.max = this.querySelector('[data-pr="max"]');
        this.fill = this.querySelector('[data-pr-fill]');
        this.outMin = this.querySelector('[data-pr-out="min"]');
        this.outMax = this.querySelector('[data-pr-out="max"]');
        if (!this.min || !this.max) return;

        this.symbol = this.dataset.symbol || '';
        this.ceiling = Number(this.max.max) || 0;

        this.onInput = this.onInput.bind(this);
        this.addEventListener('input', this.onInput);
        // Runs before the document-level submit handler, so the cleanup below
        // decides what actually goes into the query string.
        this.addEventListener('change', () => this.trim());
        this.paint();
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.onInput);
      }

      onInput(e) {
        if (!e.target.matches('[data-pr]')) return;
        // The dragged thumb wins and pushes the other one along. Making it give
        // way instead deadlocks: with both thumbs parked on the ceiling neither
        // could ever be moved back down.
        if (Number(this.min.value) > Number(this.max.value)) {
          if (e.target === this.min) this.max.value = this.min.value;
          else this.min.value = this.max.value;
        }
        this.paint();
      }

      /* A value still sitting at its extreme was never chosen — don't submit it. */
      trim() {
        this.min.disabled = Number(this.min.value) <= 0;
        this.max.disabled = Number(this.max.value) >= this.ceiling;
      }

      money(n) {
        return this.symbol + Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 });
      }

      paint() {
        const lo = Number(this.min.value);
        const hi = Number(this.max.value);
        // The max input is painted over the min one, so a min thumb sitting at
        // the top of the track would be unreachable — lift it above.
        this.min.style.zIndex = lo >= this.ceiling ? '2' : '';
        if (this.outMin) this.outMin.textContent = this.money(lo);
        if (this.outMax) this.outMax.textContent = this.money(hi);
        if (this.fill && this.ceiling > 0) {
          this.fill.style.left = `${(lo / this.ceiling) * 100}%`;
          this.fill.style.right = `${100 - (hi / this.ceiling) * 100}%`;
        }
      }
    }
  );
}
